import { getEnv as i } from "../lib/env.js";
import { isInOneNav as s } from "../onenav/is-in-onenav.js";
import { isInData as o } from "../onenav/routing.js";
import "cerulean/dist/lib/product";
import "../lib/location.js";
const a = process.env.NODE_ENV, _ = "prod-eu", r = "production", d = "staging";
var N = /* @__PURE__ */ ((e) => (e.US = "us-west-2", e.EU = "eu-central-1", e))(N || {});
const g = (e) => e === "test" ? "" : "https://f7003d3a8d52453a834e096cb203501c@o13027.ingest.sentry.io/78869", L = (e, t) => {
  if (t === "test")
    return "";
  if (t === "development" || t === "perf")
    return "ba4b96b3b6cde1d722e60aac370093c7";
  switch (e) {
    case r:
      return "e5a2c9bdffe949f7da77e6b481e118fa";
    case "staging":
    case "prod-sandbox":
      return "a3c23da3b63f5b6bed50b0b6f252567f";
    case "development":
      return "ce58b28cace35f7df0eb241b0cd72044";
    case _:
      return "4ccbf62d3b2a2b840cdc385c724a68ca";
    default:
      return "";
  }
}, l = (e, t) => {
  if (t === "test")
    return null;
  switch (e) {
    case _:
      return {
        key: "c4918f03c986765e0d7b495199f86e48",
        serverZone: "EU"
      };
    default:
      return null;
  }
}, A = (e, t) => {
  switch (t) {
    case "test":
      return "";
    case "development":
    case "perf":
      return "bb4c3eafb5ccb0f0e73e32dd5c63ecda";
  }
  switch (e) {
    case r:
      return "fb0efa3ca84d3fa90b9722e73a65c730";
    case _:
      return "93be69dba20cd60ddd9d3a48e176ceac";
    default:
      return "";
  }
}, u = (e, t) => {
  switch (t) {
    case "test":
    case "perf":
      return "development";
    case "development":
      return "local";
  }
  switch (e) {
    case r:
      return "production";
    case "staging":
    case "prod-sandbox":
      return "staging";
    case "development":
      return "development";
    case _:
      return "prodeu";
    default:
      return "development";
  }
}, U = (e, t, c) => {
  if (c === "test")
    return "";
  if (t === _)
    return "2359418194.2175895532818";
  switch (e) {
    case "prod":
      return "2359418194.79837860256";
    case "stag":
    case "dev":
    default:
      return "2359418194.77355742816";
  }
}, T = () => "391178095022400", E = () => "TODO_AD_ID", S = (e) => e === _ ? ["3.124.22.25", "18.157.59.125", "18.192.47.195"] : ["52.33.3.219", "52.27.10.221", "35.162.216.242"], P = (e) => {
  switch (e) {
    case _:
      return "eu-central-1";
    case r:
    default:
      return "us-west-2";
  }
}, O = (e) => e === _ ? "vpce-0ea17096d8975a789" : "vpce-88b275e1", Q = (e) => e === _ ? "arn:aws:iam::202493300829:root" : "arn:aws:iam::358203115967:root", m = (e, t) => {
  if (t === "test")
    return "";
  switch (e) {
    case r:
      return "client-TOagPM8vfADC9LhZwsUjF04G6g6QKGnt";
    case _:
      return "client-NH902YI9HX5xgNzlUUUsxKNFYIab7NZZ";
    case "staging":
    case "prod-sandbox":
      return "client-75jOyETRMUlbhbwa1GcuXRwxycj7JL4Q";
    case "development":
    default:
      return "client-Vne8KdiZLCS9P6jeTKVAnitvKdV1irtV";
  }
}, M = (e, t) => {
  if (t === "test")
    return "";
  switch (e) {
    case r:
      return "client-GyxvAihJLEL1CBkpmrgHkiMXvEo93TUZ";
    case _:
      return "client-56uIPC0LGe0XXinktzdHtlTe3wWBtp6t";
    case "staging":
    case "prod-sandbox":
      return "client-K5yOijjSKqIs9aHedgKUncOvi1KWeqMz";
    case "development":
    default:
      return "client-7GtYXpQxRVXpbxOJszfwPUq9NKkwhKLK";
  }
}, f = (e, t) => {
  if (t === "test")
    return "";
  switch (e) {
    case r:
      return "client-T48zq8Ph4z7MY185gwy9qf2ZWYptjJOW";
    case _:
      return "client-WUybuSZBR5imrpbVc92vfo4G1eub1V81";
    case "staging":
    case "prod-sandbox":
      return "client-AsPMVbYmw247R5zYDlqsYb0nvxSgSXe0";
    case "development":
    default:
      return "client-bCxcfSA7VBs0ek8TYjF9YsOvKusZ42k3";
  }
}, C = (e) => e === _ ? "100000002" : "36958", Y = (e) => e === _ ? {
  DEFAULT: "amplitude_prod_eu",
  LAST_EDITED_DATE_ASC: "amplitude_prod_eu_sort_by_last_modified_asc",
  LAST_EDITED_DATE_DESC: "amplitude_prod_eu_sort_by_last_modified",
  NAME_ASC: "amplitude_prod_eu_sort_by_name_asc",
  NAME_DESC: "amplitude_prod_eu_sort_by_name_desc",
  TOTAL_VIEWS_ASC: "amplitude_prod_eu_sort_by_total_views_asc",
  TOTAL_VIEWS_DESC: "amplitude_prod_eu_sort_by_total_views"
} : {
  DEFAULT: "amplitude_production",
  LAST_EDITED_DATE_ASC: "amplitude_production_sort_by_last_modified_asc",
  LAST_EDITED_DATE_DESC: "amplitude_production_sort_by_last_modified",
  NAME_ASC: "amplitude_production_sort_by_name_asc",
  NAME_DESC: "amplitude_production_sort_by_name_desc",
  TOTAL_VIEWS_ASC: "amplitude_production_sort_by_total_views_asc",
  TOTAL_VIEWS_DESC: "amplitude_production_sort_by_total_views"
}, v = (e) => e === _ ? "QKAXZ4SEIN" : "MRQCO3H43U", I = () => "Using_this_{AG_Grid}_Enterprise_key_{AG-051425}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Amplitude}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{3_February_2025}____[v3]_[01]_MTczODU0MDgwMDAwMA==59fe4a620fc5e7c064f6c15133efd7fc", R = (e) => e === _ ? "https://static.eu.amplitude.com" : "https://static.amplitude.com", h = (e, t) => t === "development" ? "283fce0b-158e-4f80-a06d-3e439c2b7e19" : e === "staging" ? "45d79374-69cc-4554-8119-a7b13974c87a" : e === _ ? "aafdfbf9-60a1-40dc-bd65-aaa90ff19a7b" : "30826bf7-cfab-4c24-ae77-b5ddd877a15e", V = (e, t) => t === "development" ? "6811cb3d-e012-495a-8295-d5f63bf87a19" : e === _ ? "70b91d47-9fdb-4803-a542-845c222c31dd" : "ebe8696e-b615-461d-897d-dbba95ad1026", w = (e, t) => t === "development" ? "http://localhost:3001/config/hubspot/auth" : e === _ ? "https://analytics.eu.amplitude.com/config/hubspot/auth" : "https://analytics.amplitude.com/config/hubspot/auth", b = (e, t) => {
  switch (t) {
    case "development":
      return {
        clientID: "631944772372",
        redirectURI: "http://127.0.0.1:3000/config/mailchimp/auth"
      };
    case "perf":
    case "test":
      return {
        clientID: "",
        redirectURI: ""
      };
  }
  switch (e) {
    case r:
      return {
        clientID: "533899365394",
        redirectURI: "https://analytics.amplitude.com/config/mailchimp/auth"
      };
    case "staging":
    case "prod-sandbox":
      return {
        clientID: "998197057866",
        redirectURI: "https://analytics.staging.amplitude.com/config/mailchimp/auth"
      };
    case _:
      return {
        clientID: "719164686963",
        redirectURI: "https://analytics.eu.amplitude.com/config/mailchimp/auth"
      };
    default:
      return {
        clientID: "",
        redirectURI: ""
      };
  }
}, x = (e, t) => {
  switch (t) {
    case "development":
      return {
        clientID: "bdf1f132e4273742437fabdcfbbb21df",
        redirectURI: "https://127.0.0.1:3000/config/integration-oauth/callback"
      };
    case "perf":
    case "test":
      return {
        clientID: "",
        redirectURI: ""
      };
  }
  switch (e) {
    case r:
      return {
        clientID: "cc1a6b6bfb112f7dc7fbea9c6fc89ac6",
        redirectURI: "https://analytics.amplitude.com/config/integration-oauth/callback"
      };
    case "staging":
    case "prod-sandbox":
      return {
        clientID: "c5ca1ec0fa1dc9fde273dc956d5ea656",
        redirectURI: "https://analytics.staging.amplitude.com/config/integration-oauth/callback"
      };
    case _:
      return {
        clientID: "55864d8a4fbe708236989014b6611e36",
        redirectURI: "https://analytics.eu.amplitude.com/config/integration-oauth/callback"
      };
    default:
      return {
        clientID: "",
        redirectURI: ""
      };
  }
}, j = (e, t) => {
  switch (t) {
    case "development":
      return {
        clientID: "7103819669118648322",
        redirectURI: "http://127.0.0.1:3000/config/tiktokads/auth"
      };
    case "perf":
    case "test":
      return {
        clientID: "",
        redirectURI: ""
      };
  }
  switch (e) {
    case r:
      return {
        clientID: "7099694989835239425",
        redirectURI: "https://analytics.amplitude.com/config/tiktokads/auth"
      };
    case "staging":
    case "prod-sandbox":
      return {
        clientID: "7099695140096196610",
        redirectURI: "https://analytics.staging.amplitude.com/config/tiktokads/auth"
      };
    case _:
      return {
        clientID: "7102524732683059202",
        redirectURI: "https://analytics.eu.amplitude.com/config/tiktokads/auth"
      };
    default:
      return {
        clientID: "",
        redirectURI: ""
      };
  }
}, K = (e, t) => {
  switch (t) {
    case "development":
      return {
        clientID: "7361e8c3-96fb-4475-a68b-ece34ce3dfc6",
        redirectURI: "https://127.0.0.1:3000/config/integration-oauth/callback"
      };
    case "perf":
    case "test":
      return {
        clientID: "",
        redirectURI: ""
      };
  }
  switch (e) {
    case r:
      return {
        clientID: "632eb6c5-25c4-4bae-8b6f-7bafd18d4398",
        redirectURI: "https://analytics.amplitude.com/config/integration-oauth/callback"
      };
    case "staging":
    case "prod-sandbox":
      return {
        clientID: "a7f18a09-b0f8-4eb6-92b1-65b1bb62424b",
        redirectURI: "https://analytics.staging.amplitude.com/config/integration-oauth/callback"
      };
    case _:
      return {
        clientID: "7d3616d8-81a3-4d1a-9b49-1b3f1e5264f9",
        redirectURI: "https://analytics.eu.amplitude.com/config/integration-oauth/callback"
      };
    default:
      return {
        clientID: "",
        redirectURI: ""
      };
  }
}, J = (e, t) => {
  switch (t) {
    case "development":
      return {
        clientID: "3MVG9gDRuIiLyYCp2wc.rq5glNG9fLqP2rHewiMOK13jg..0hKIKGKW.4UMcQIZbHHmrDZcL68nhi1Ww5GfAY",
        redirectURI: "http://localhost:3001/config/integration-oauth/callback"
      };
    case "perf":
    case "test":
      return {
        clientID: "",
        redirectURI: ""
      };
  }
  switch (e) {
    case r:
      return {
        clientID: "3MVG9fMtCkV6eLhdpgzRSQyseA3BX216XgDyZxtpyOLN9.eoBdEtshIN2tRoj4d7X8l7EOfp41Qaet1xXS9CH",
        redirectURI: "https://analytics.amplitude.com/config/integration-oauth/callback"
      };
    case "staging":
    case "prod-sandbox":
      return {
        clientID: "3MVG9gDRuIiLyYCp2wc.rq5glNG9fLqP2rHewiMOK13jg..0hKIKGKW.4UMcQIZbHHmrDZcL68nhi1Ww5GfAY",
        redirectURI: "https://analytics.staging.amplitude.com/config/integration-oauth/callback"
      };
    case _:
      return {
        clientID: "3MVG9fMtCkV6eLhdpgzRSQyseA3BX216XgDyZxtpyOLN9.eoBdEtshIN2tRoj4d7X8l7EOfp41Qaet1xXS9CH",
        redirectURI: "https://analytics.eu.amplitude.com/config/integration-oauth/callback"
      };
    default:
      return {
        clientID: "",
        redirectURI: ""
      };
  }
}, H = (e, t) => {
  if (t === "development")
    return "http://localhost:3007";
  switch (e) {
    case r:
      return "https://notify.amplitude.com";
    case _:
      return "https://notify.eu.amplitude.com";
    case "staging":
    case "prod-sandbox":
      return "https://notify.staging.amplitude.com";
    case "development":
    default:
      return "https://notify.dev.amplitude.com";
  }
}, D = (e) => e === r ? "https://api.amplitude.com" : e === _ ? "https://api.eu.amplitude.com" : "", y = (e, t) => e === _ ? "https://api.eu.amplitude.com/2/httpapi" : "https://api.amplitude.com/2/httpapi", k = (e, t) => e === _ ? "https://api.eu.amplitude.com/2/httpapi" : "https://api2.amplitude.com/2/httpapi", X = (e, t) => {
  switch (t) {
    case "development":
      return "http://localhost:3000/config/adapter-v2/jsonata-template";
    case "perf":
    case "test":
      return "";
  }
  switch (e) {
    case r:
      return "https://analytics.amplitude.com/config/adapter-v2/jsonata-template";
    case "staging":
    case "prod-sandbox":
      return "https://analytics.staging.amplitude.com/config/adapter-v2/jsonata-template";
    case _:
      return "https://analytics.eu.amplitude.com/config/adapter-v2/jsonata-template";
    default:
      return "";
  }
}, G = (e, t) => {
  switch (t) {
    case "development":
      return "http://localhost:3000/config/adapter-v2/customer-template";
    case "perf":
    case "test":
      return "";
  }
  switch (e) {
    case r:
      return "https://analytics.amplitude.com/config/adapter-v2/customer-template";
    case "staging":
    case "prod-sandbox":
      return "https://analytics.staging.amplitude.com/config/adapter-v2/customer-template";
    case _:
      return "https://analytics.eu.amplitude.com/config/adapter-v2/customer-template";
    default:
      return "";
  }
}, B = (e, t) => {
  switch (t) {
    case "development":
      return "http://localhost:3000/config/mailchimp/webhook";
    case "perf":
    case "test":
      return "";
  }
  switch (e) {
    case r:
      return "https://analytics.amplitude.com/config/mailchimp/webhook";
    case "staging":
    case "prod-sandbox":
      return "https://analytics.staging.amplitude.com/config/mailchimp/webhook";
    case _:
      return "https://analytics.eu.amplitude.com/config/mailchimp/webhook";
    default:
      return "";
  }
}, W = (e, t) => {
  if (t === "development")
    return "http://localhost:3005";
  switch (e) {
    case r:
      return "https://data.amplitude.com";
    case _:
      return "https://data.eu.amplitude.com";
    case "staging":
    case "prod-sandbox":
      return "https://data.staging.amplitude.com";
    case "development":
    default:
      return "https://data.dev.amplitude.com";
  }
}, Z = (e, t) => {
  const c = {
    version: "1",
    key: "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA7avYdn04kWmYfu+4+9DGz7YMJMUP3FlySbVKTZW/gr2ta3EgSJecQqC+0h7or18xSo1melPymeTg62g+ri8Vxpdr6BYIevRVvtij/pv9oB4XOepsNg5OS99cfatjZIrplTcoeSyVZ27dyBvxV8in1BekkCmlLPkzHp3P9Zf7Fdccy4TQGJyr2mqTrNkCPsmHADv5lizdmk5evXIVJ8rv5M0zBIfuMzokgEi8HLP1Dsc6n3FFR97MJTd5Tu/sUIsJ8QBQpJhD7wf+HzHPcdMMjQ+r/ra619ZM5LSXdwGnlJ/FqIkowyo+MucgsfJVL/DG8huTwU4jw01E6gTw2Ra8i29uHmEDS+HMzEt0rUJsV2lqEockCOLjdk3LAYCEZBYekkk01RfiJgv/5FgCwjrtXISdZ0pLIUE+/SyNZSkqUcq9uMmPd3uMRs+Bife9uylbFNGXXSh5GT7Xg23QBYgL0tg8ZL7l0l6mXNbL1s7nR7O9Jv3ZtE6mHOxmDOm0vJQ/e9GYccZGOU+YBdcrILXJRnuPVYSdNwQ7cVgUnicJp6vcgnNHSsdYLtCNwWJq9eQv279gkb5X6fRwt9npo5dGhWMN0aXUiLBMRTIHyOqUHqKSSyxrFO89HB0CVUt5vtz0JapRBDSnrB1MYH4832iiztq1ShuIDPDZG0cLvEIp8HUCAwEAAQ=="
  }, n = {
    version: "1",
    key: "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAkps25IQayeH5oexwWoukfVdJ9Ck2jP1hBaRYn5JBMk23MTlr7cZooXGm6GD0ZjJ2akFd9ZWBkkLf7cXnWEbOwgv/iSESJMga/ubWBlh9MsOJFMfRIxgMr8Rd5JUoOmr9/qAE3+vGnwTFWmVrNLV31r+WDXe1894EX+HM1RRXCL6k3s13xeGw2nFnwZVwbeUZdMlxapI5VYnJOh/mZP3nl1D6ZSjvTWkawMarOVZrhh7Wl5N5TCdrEQh+8rWg3MeZshYtuV2VaYdaWrKQLRHvlqLOIXs6bbGAXOQskDT8IvM5jmj9O4iPg5gLu0i0OKRikG8wH4wQ3aqyfUINl8rI/+WZfOxaM+hgv3AFehL+6O/ZuyXn3qIJ7p17o8YfRhavuiK8LeHy4CB9LJEzJxeAfgxXB2dZYkhKnKFAFpdzvesIz648PafWMbNUIyLLiIr910tfFIr/5EA1gTwTA5k/JdifEAje80QGNt2i/3Z7A+2/tDRPgrLcXxqk0gjFiSAnllbeZORjqf6Fe0gM5Zfc8e2fg2nB46N9t2KMSCXD9fXMcTikHzaeCfa1LQ9+ovm+t+lz8Lgw57fZJnffEnFqHbxp8fdsLq+r1ANFNg2KQUJp+G4Cb+eC84FUpPBpwbzoJCEAOU6uwE03wQtrvJY9TTwr2PwKFS35qPN1YwGaFqsCAwEAAQ=="
  }, p = {
    version: "1",
    key: "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA1sVCAW1GTnga3A0yTGZOYflj4hyStyiHovQhK/MOmvl6Hlh6RDpXEnmrcfXwiFukmAJESjzdDtartj6VpkOaEKQ/yTEBvs2FtQVAq3ry1g+j0g2DCbj86lTm+2UkVGAPGnGv0BRO+1M/irqxZ4UhRic/BwFU+OfpGDeE88SriaU9CF3DmE6IDge/6uCm9bdSHGYLmCLsDXE/lI6CQ8pQLMJy9JDNP3MbkPSaLArrCY3dn3FS6Y9YVxZxHBAvIjdzSq+DfBJ51nLwMvROj01Gziy0EMWAk0HMysyg0x4Vujrpg2N3cAp+3cegMZLisTgH77knm0DjZtYFZiTItEfnBBEL5GZrYCDcAp89/rX5EpFwZNXqPdK6vaDAASQ9NtOEh66j0TW48mVJ6vkVKlZi3txTomeh8mm9WASl6qjeX1yHc8MmOi8JRgOQMMV1NAbLckGtHN7Y7d490EULTHzvD/cAL+0uUvxWBptkEs3YG0R8XKuheCWk10sHS+vwrWaNIybRJT8Saeh2TdQXzCEnfqCwgYzQNJ6sCH9kKTRoz8GkAyIBRpRCQ2oldBMtzjcreNXFv0QSqlvR6gMkuzIp0k84pUBCk5eoqFi+RUu9liVco20VIiIymKUlrkvcP1GXPrc3VHPh3M7q8PFVwaELyD++I/ha8KzMCbT/d0wuTcsCAwEAAQ=="
  };
  if (t === "development")
    return c;
  switch (e) {
    case r:
      return n;
    case _:
      return p;
    case "staging":
    case "prod-sandbox":
    case "development":
    default:
      return c;
  }
}, F = (e, t) => {
  const c = "ct_xwegrbo2yjgv3dkyzpmysjve6i";
  if (t === "development")
    return c;
  switch (e) {
    case r:
    case _:
      return "ct_hwkn3nviz5gjnb53iixkwhmc2q";
    case "staging":
    case "prod-sandbox":
    case "development":
    default:
      return c;
  }
}, q = (e, t) => {
  if (t === "development")
    return "A02HXJELM6Y";
  switch (e) {
    case r:
      return "A02PDFHC1NX";
    case _:
      return "";
    case "staging":
    case "prod-sandbox":
      return "A02NYR6E9V5";
    case "development":
    default:
      return "A02KU7WQZD0";
  }
}, z = (e, t) => {
  if (s())
    return i("REACT_APP_ANALYTICS_HOST");
  if (t === "development")
    return "http://localhost:3001";
  switch (e) {
    case r:
      return "https://analytics.amplitude.com";
    case _:
      return "https://analytics.eu.amplitude.com";
    case "staging":
      return "https://analytics.staging.amplitude.com";
    case "prod-sandbox":
      return "https://analytics.prod-sandbox.amplitude.com";
    case "development":
    default:
      return "https://analytics.dev.amplitude.com";
  }
}, $ = (e, t) => {
  if (t === "development")
    return "http://localhost:3002/admin-v2";
  switch (e) {
    case r:
      return "https://analytics.amplitude.com/admin-v2";
    case _:
      return "https://analytics.eu.amplitude.com/admin-v2";
    case "staging":
      return "https://analytics.staging.amplitude.com/admin-v2";
    case "prod-sandbox":
      return "https://analytics.prod-sandbox.amplitude.com/admin-v2";
    case "development":
    default:
      return "https://analytics.dev.amplitude.com/admin-v2";
  }
}, ee = (e, t) => {
  if (t === "development")
    return s() ? `${i("REACT_APP_ORBIT_HOST")}/o` : "http://localhost:4000";
  if (s())
    return `${i("REACT_APP_ORBIT_HOST")}`;
  if (o)
    return process.env.REACT_APP_ORBIT_HOST || "";
  switch (e) {
    case r:
      return "https://data-api.amplitude.com";
    case _:
      return "https://data-api.eu.amplitude.com";
    case "prod-sandbox":
      return "https://data-api.prod-sandbox.amplitude.com";
    case "staging":
      return "https://data-api.staging.amplitude.com";
    case "local":
    default:
      return "http://localhost:4000";
  }
}, te = (e) => s() ? `${i("REACT_APP_THUNDER_HOST")}/t` : e === "development" ? "http://localhost:3030" : `${window.location.origin}/t`, _e = (e) => s() ? i("REACT_APP_DASH_HOST") : e === "development" ? "http://localhost:3000" : `${window.location.origin}`, ae = (e, t) => {
  if (t === "development")
    return "https://localhost:3010";
  switch (e) {
    case r:
      return "https://app.amplitude.com";
    case _:
      return "https://app.eu.amplitude.com";
    case "staging":
      return "https://apps.stag2.amplitude.com";
    case "prod-sandbox":
      return "https://app.prod-sandbox.amplitude.com";
    case "development":
    default:
      return "https://app.dev.amplitude.com";
  }
}, re = (e, t) => {
  if (t === "development")
    return "http://localhost:3004";
  switch (e) {
    case r:
      return "https://app.amplitude.com";
    case _:
      return "https://app.eu.amplitude.com";
    case "staging":
      return "https://apps.stag2.amplitude.com";
    case "prod-sandbox":
      return "https://app.prod-sandbox.amplitude.com";
    case "development":
    default:
      return process.env.CI !== "true" && console.warn("Unknown cerebro host"), "";
  }
}, ce = (e, t) => {
  const c = {
    PLANS: {
      // Plus V1 Plan Price IDs (legacy)
      PLUS_PLAN_5M: "price_0L7np17vaQQgJjsxiNbqke46",
      PLUS_PLAN_10M: "price_0L7npk7vaQQgJjsxx1lWBRNV",
      // Plus V2 Plan Price IDs (legacy)
      PLUS_PLAN_MTU_25K_YEARLY: "price_0M207q7vaQQgJjsxniUqQIvx",
      PLUS_PLAN_MTU_50K_YEARLY: "price_0M209B7vaQQgJjsxGJIQxSCz",
      PLUS_PLAN_MTU_100K_YEARLY: "price_0M20BG7vaQQgJjsx6l0F46P6",
      PLUS_PLAN_MTU_25K_MONTHLY: "price_0M4Gd47vaQQgJjsx5ZG1ZjAw",
      PLUS_PLAN_MTU_50K_MONTHLY: "price_0M4VtH7vaQQgJjsxJQmRGCAU",
      PLUS_PLAN_MTU_100K_MONTHLY: "price_0M4Vtd7vaQQgJjsx29UlK9Tf",
      // Plus V3 Plan Price IDs
      PLUS_V3_PLAN_MTU_1K_YEARLY: "price_0NXU6v7vaQQgJjsxHo3Ke22s",
      "PLUS_V3_PLAN_MTU_2.5K_YEARLY": "price_0PgYq07vaQQgJjsxfeHWdggC",
      PLUS_V3_PLAN_MTU_5K_YEARLY: "price_0NXU9k7vaQQgJjsxNxjX3dwG",
      PLUS_V3_PLAN_MTU_10K_YEARLY: "price_0NXUBR7vaQQgJjsxvIIML5wL",
      PLUS_V3_PLAN_MTU_25K_YEARLY: "price_0NXUCE7vaQQgJjsx5p5r0wm7",
      PLUS_V3_PLAN_MTU_50K_YEARLY: "price_0NXUE77vaQQgJjsxswPT1hVA",
      PLUS_V3_PLAN_MTU_75K_YEARLY: "price_0PgabF7vaQQgJjsxBo4V74rt",
      PLUS_V3_PLAN_MTU_100K_YEARLY: "price_0NXUGr7vaQQgJjsxpCrOoNj5",
      PLUS_V3_PLAN_MTU_150K_YEARLY: "price_0PgabH7vaQQgJjsxpSPQAl5w",
      PLUS_V3_PLAN_MTU_200K_YEARLY: "price_0NXUHk7vaQQgJjsxPC8GXuzq",
      PLUS_V3_PLAN_MTU_300K_YEARLY: "price_0NXUIR7vaQQgJjsxCc4OEbcU",
      PLUS_V3_PLAN_MTU_1K_MONTHLY: "price_0NXU6v7vaQQgJjsxGBcSBnB6",
      "PLUS_V3_PLAN_MTU_2.5K_MONTHLY": "price_0PgYpz7vaQQgJjsxr9a1seld",
      PLUS_V3_PLAN_MTU_5K_MONTHLY: "price_0NXU9k7vaQQgJjsx9dZpki2F",
      PLUS_V3_PLAN_MTU_10K_MONTHLY: "price_0NXUBR7vaQQgJjsxIeBsbW6N",
      PLUS_V3_PLAN_MTU_25K_MONTHLY: "price_0NXUCE7vaQQgJjsxKfZeTtUh",
      PLUS_V3_PLAN_MTU_50K_MONTHLY: "price_0NXUE77vaQQgJjsxhL4PqEAv",
      PLUS_V3_PLAN_MTU_75K_MONTHLY: "price_0PgabE7vaQQgJjsx1zRBDrtj",
      PLUS_V3_PLAN_MTU_100K_MONTHLY: "price_0NXUGr7vaQQgJjsxXYu01xdL",
      PLUS_V3_PLAN_MTU_150K_MONTHLY: "price_0PgabH7vaQQgJjsxmKIdUilh",
      PLUS_V3_PLAN_MTU_200K_MONTHLY: "price_0NXUHk7vaQQgJjsxatmCKmwp",
      PLUS_V3_PLAN_MTU_300K_MONTHLY: "price_0NXUIR7vaQQgJjsxaDu1Pz90",
      // Plus V3 EV Plan Intital Testing Price IDs
      PLUS_V3_PLAN_EV_20M_YEARLY: "price_0P5u267vaQQgJjsx4dSKIOhk",
      PLUS_V3_PLAN_EV_20M_MONTHLY: "price_0P5tzh7vaQQgJjsxfEcJL51x",
      PLUS_V3_PLAN_EV_10M_YEARLY: "price_0Oqiau7vaQQgJjsxBHjnNUkX",
      PLUS_V3_PLAN_EV_10M_MONTHLY: "price_0OqiaF7vaQQgJjsxOvyyGy6R",
      PLUS_V3_PLAN_EV_5M_YEARLY: "price_0Ow9rL7vaQQgJjsxBvuQwqkb",
      PLUS_V3_PLAN_EV_5M_MONTHLY: "price_0Ow9qn7vaQQgJjsxLn41JxEZ"
    },
    ADDONS: {
      // Accounts for Plus V1 Price IDs (legacy)
      ACCOUNTS_5M_YEARLY: "price_0MgETg7vaQQgJjsxpbjuwWfW",
      ACCOUNTS_10M_YEARLY: "price_0MgEUi7vaQQgJjsxvlQ8uCrt",
      // Accounts for Plus V2 Price IDs (legacy)
      ACCOUNTS_25K_YEARLY: "price_0MYZN07vaQQgJjsxU6moYsfW",
      ACCOUNTS_50K_YEARLY: "price_0MYZLr7vaQQgJjsxiGTeo9yq",
      ACCOUNTS_100K_YEARLY: "price_0MWTUB7vaQQgJjsxoIGMTTQ3",
      ACCOUNTS_25K_MONTHLY: "price_0MYZNf7vaQQgJjsxfY8KsIfJ",
      ACCOUNTS_50K_MONTHLY: "price_0MYZMO7vaQQgJjsxgmyKUNYu",
      ACCOUNTS_100K_MONTHLY: "price_0MYZL87vaQQgJjsx7Gnf2vYm",
      // Accounts for Plus V3 Price IDs
      ACCOUNTS_PLUS_V3_1K_YEARLY: "price_0NXUQ77vaQQgJjsx3WvWi703",
      "ACCOUNTS_PLUS_V3_2.5K_YEARLY": "price_0PgYq17vaQQgJjsx0zd0alL5",
      ACCOUNTS_PLUS_V3_5K_YEARLY: "price_0NXUQQ7vaQQgJjsxd4SwKn1N",
      ACCOUNTS_PLUS_V3_10K_YEARLY: "price_0NXUR37vaQQgJjsxLSz9o0fs",
      ACCOUNTS_PLUS_V3_25K_YEARLY: "price_0NXURN7vaQQgJjsx5GL3Mhpf",
      ACCOUNTS_PLUS_V3_50K_YEARLY: "price_0NXURz7vaQQgJjsxHbxpfcMs",
      ACCOUNTS_PLUS_V3_75K_YEARLY: "price_0PgabG7vaQQgJjsxzsh3SpYK",
      ACCOUNTS_PLUS_V3_100K_YEARLY: "price_0NXUSc7vaQQgJjsxZFDXZw57",
      ACCOUNTS_PLUS_V3_150K_YEARLY: "price_0PgabI7vaQQgJjsxWh0NmajD",
      ACCOUNTS_PLUS_V3_200K_YEARLY: "price_0NXUTD7vaQQgJjsxUwZ65B8T",
      ACCOUNTS_PLUS_V3_300K_YEARLY: "price_0NXUTc7vaQQgJjsxHCZYg4JV",
      ACCOUNTS_PLUS_V3_1K_MONTHLY: "price_0NXUPg7vaQQgJjsxUf4IKC7T",
      "ACCOUNTS_PLUS_V3_2.5K_MONTHLY": "price_0PgYq17vaQQgJjsxJkgM4DMH",
      ACCOUNTS_PLUS_V3_5K_MONTHLY: "price_0NXUPg7vaQQgJjsxcPA8cKHc",
      ACCOUNTS_PLUS_V3_10K_MONTHLY: "price_0NXUPg7vaQQgJjsx4IoTpmQD",
      ACCOUNTS_PLUS_V3_25K_MONTHLY: "price_0NXUPg7vaQQgJjsxBBUXTeaQ",
      ACCOUNTS_PLUS_V3_50K_MONTHLY: "price_0NXUPg7vaQQgJjsx6CdeWfro",
      ACCOUNTS_PLUS_V3_75K_MONTHLY: "price_0PgabH7vaQQgJjsxmKIdUilh",
      ACCOUNTS_PLUS_V3_100K_MONTHLY: "price_0NXUPg7vaQQgJjsxUGIkAWUw",
      ACCOUNTS_PLUS_V3_150K_MONTHLY: "price_0PgabI7vaQQgJjsx71tqV3aQ",
      ACCOUNTS_PLUS_V3_200K_MONTHLY: "price_0NXUPg7vaQQgJjsxEfow8uVo",
      ACCOUNTS_PLUS_V3_300K_MONTHLY: "price_0NXUPg7vaQQgJjsxr15jyaVJ",
      // Plus V3 EV Plan Intital Testing Price IDs
      ACCOUNTS_PLUS_V3_20M_YEARLY: "price_0P5u9D7vaQQgJjsxOgUSfHgc",
      ACCOUNTS_PLUS_V3_10M_YEARLY: "price_0OwA6n7vaQQgJjsx3TZnPBbz",
      ACCOUNTS_PLUS_V3_5M_YEARLY: "price_0OwA897vaQQgJjsxJJgwQiNA",
      ACCOUNTS_PLUS_V3_20M_MONTHLY: "price_0P5u7W7vaQQgJjsxZGj8lwlW",
      ACCOUNTS_PLUS_V3_10M_MONTHLY: "price_0OwA6Q7vaQQgJjsxz784TtUS",
      ACCOUNTS_PLUS_V3_5M_MONTHLY: "price_0OwA7O7vaQQgJjsx0pPmE23f"
    }
  };
  if (t === "development")
    return c;
  const n = {
    PLANS: {
      // Plus V1 Plan Price IDs (legacy)
      PLUS_PLAN_5M: "price_0L61qB7vaQQgJjsxvIXNYjE5",
      PLUS_PLAN_10M: "price_0L624j7vaQQgJjsxG1McEbXK",
      // Plus V2 Plan Price IDs (legacy)
      PLUS_PLAN_MTU_25K_YEARLY: "price_0M205X7vaQQgJjsx6UO9NHgr",
      PLUS_PLAN_MTU_50K_YEARLY: "price_0M209z7vaQQgJjsxC1C6u1lw",
      PLUS_PLAN_MTU_100K_YEARLY: "price_0M20CS7vaQQgJjsxixjcWUPM",
      PLUS_PLAN_MTU_25K_MONTHLY: "price_0M4Vuz7vaQQgJjsxZl6aFSaA",
      PLUS_PLAN_MTU_50K_MONTHLY: "price_0M4VvN7vaQQgJjsxkRjkO3Or",
      PLUS_PLAN_MTU_100K_MONTHLY: "price_0M4Vvr7vaQQgJjsxbIt2uppY",
      // Plus V3 Plan Price IDs
      PLUS_V3_PLAN_MTU_1K_YEARLY: "price_0NXWoi7vaQQgJjsxlr6EZEcw",
      "PLUS_V3_PLAN_MTU_2.5K_YEARLY": "price_0PgXgo7vaQQgJjsx8srg2Gdf",
      PLUS_V3_PLAN_MTU_5K_YEARLY: "price_0NXWoe7vaQQgJjsxiBb8vrrk",
      PLUS_V3_PLAN_MTU_10K_YEARLY: "price_0NXWoZ7vaQQgJjsx8jzAGhKK",
      PLUS_V3_PLAN_MTU_25K_YEARLY: "price_0NXWoV7vaQQgJjsxpN9dCzZE",
      PLUS_V3_PLAN_MTU_50K_YEARLY: "price_0NXWoK7vaQQgJjsxtU9pju1Y",
      PLUS_V3_PLAN_MTU_75K_YEARLY: "price_0PgbYj7vaQQgJjsxI4nRWyOv",
      PLUS_V3_PLAN_MTU_100K_YEARLY: "price_0NXWoG7vaQQgJjsxZGnCkqvr",
      PLUS_V3_PLAN_MTU_150K_YEARLY: "price_0PgbYl7vaQQgJjsx4HnK9UL2",
      PLUS_V3_PLAN_MTU_200K_YEARLY: "price_0NXWoD7vaQQgJjsxgkAYEwQf",
      PLUS_V3_PLAN_MTU_300K_YEARLY: "price_0NXWo87vaQQgJjsxd2FZx5Os",
      PLUS_V3_PLAN_MTU_1K_MONTHLY: "price_0NXWoi7vaQQgJjsxurktAN0E",
      "PLUS_V3_PLAN_MTU_2.5K_MONTHLY": "price_0PgXgo7vaQQgJjsxHYdR6GD7",
      PLUS_V3_PLAN_MTU_5K_MONTHLY: "price_0NXWoe7vaQQgJjsxPsCgslhE",
      PLUS_V3_PLAN_MTU_10K_MONTHLY: "price_0NXWoZ7vaQQgJjsxX8zNQ3Z0",
      PLUS_V3_PLAN_MTU_25K_MONTHLY: "price_0NXWoV7vaQQgJjsxXl9O251j",
      PLUS_V3_PLAN_MTU_50K_MONTHLY: "price_0NXWoK7vaQQgJjsxLwIHBpuK",
      PLUS_V3_PLAN_MTU_75K_MONTHLY: "price_0PgbYi7vaQQgJjsxs7TUcFOz",
      PLUS_V3_PLAN_MTU_100K_MONTHLY: "price_0NXWoG7vaQQgJjsxW5LFzym9",
      PLUS_V3_PLAN_MTU_150K_MONTHLY: "price_0PgbYk7vaQQgJjsxUJ7LH4cl",
      PLUS_V3_PLAN_MTU_200K_MONTHLY: "price_0NXWoD7vaQQgJjsxQ267GyaD",
      PLUS_V3_PLAN_MTU_300K_MONTHLY: "price_0NXWo87vaQQgJjsxLvsYP2NA",
      // Plus V3 EV Plan Intital Testing Price IDs
      PLUS_V3_PLAN_EV_20M_YEARLY: "price_0P9x8V7vaQQgJjsxTn40n0pb",
      PLUS_V3_PLAN_EV_20M_MONTHLY: "price_0P9x8V7vaQQgJjsxcmsGVRfN",
      PLUS_V3_PLAN_EV_10M_YEARLY: "price_0Or5xY7vaQQgJjsxNrbdxCeR",
      PLUS_V3_PLAN_EV_10M_MONTHLY: "price_0Or5xY7vaQQgJjsx1AXsuLQv",
      PLUS_V3_PLAN_EV_5M_YEARLY: "price_0Ow9w37vaQQgJjsxOz7BX5US",
      PLUS_V3_PLAN_EV_5M_MONTHLY: "price_0Ow9w37vaQQgJjsxzaCUANN2"
    },
    ADDONS: {
      // Accounts for Plus V1 Price IDs (legacy)
      ACCOUNTS_5M_YEARLY: "price_0MgEbw7vaQQgJjsxEfkCryqM",
      ACCOUNTS_10M_YEARLY: "price_0MgEcH7vaQQgJjsxUj3sCpRd",
      // Accounts for Plus V2 Price IDs (legacy)
      ACCOUNTS_25K_YEARLY: "price_0MYZbr7vaQQgJjsxj2OBEpHu",
      ACCOUNTS_50K_YEARLY: "price_0MYZbr7vaQQgJjsxXneEzNot",
      ACCOUNTS_100K_YEARLY: "price_0MYZbr7vaQQgJjsxjKVRiqJi",
      ACCOUNTS_25K_MONTHLY: "price_0MYZbr7vaQQgJjsxSWY2fCuG",
      ACCOUNTS_50K_MONTHLY: "price_0MYZbr7vaQQgJjsxjRHhdrw8",
      ACCOUNTS_100K_MONTHLY: "price_0MYZbr7vaQQgJjsxtap4cqQR",
      // Accounts for Plus V3 Price IDs
      ACCOUNTS_PLUS_V3_1K_YEARLY: "price_0NXWlf7vaQQgJjsxRzJioNlh",
      "ACCOUNTS_PLUS_V3_2.5K_YEARLY": "price_0PgXgp7vaQQgJjsxFlUfiRPg",
      ACCOUNTS_PLUS_V3_5K_YEARLY: "price_0NXWlf7vaQQgJjsx2akAdRo8",
      ACCOUNTS_PLUS_V3_10K_YEARLY: "price_0NXWlf7vaQQgJjsxxjpGK7pk",
      ACCOUNTS_PLUS_V3_25K_YEARLY: "price_0NXWlf7vaQQgJjsxAECsOrpw",
      ACCOUNTS_PLUS_V3_50K_YEARLY: "price_0NXWlf7vaQQgJjsxY9lpIzuq",
      ACCOUNTS_PLUS_V3_75K_YEARLY: "price_0PgbYj7vaQQgJjsxE7n4x9lu",
      ACCOUNTS_PLUS_V3_100K_YEARLY: "price_0NXWlf7vaQQgJjsxBYZu7tMv",
      ACCOUNTS_PLUS_V3_150K_YEARLY: "price_0PgbYm7vaQQgJjsxcMUciZnS",
      ACCOUNTS_PLUS_V3_200K_YEARLY: "price_0NXWlf7vaQQgJjsxGjJZhJ5l",
      ACCOUNTS_PLUS_V3_300K_YEARLY: "price_0NXWle7vaQQgJjsxKaXlA8K6",
      ACCOUNTS_PLUS_V3_1K_MONTHLY: "price_0NXWlf7vaQQgJjsxo3EbFO4G",
      "ACCOUNTS_PLUS_V3_2.5K_MONTHLY": "price_0PgXgp7vaQQgJjsxIdttmLBp",
      ACCOUNTS_PLUS_V3_5K_MONTHLY: "price_0NXWlf7vaQQgJjsx8bK0La25",
      ACCOUNTS_PLUS_V3_10K_MONTHLY: "price_0NXWlf7vaQQgJjsxhhdwCWeb",
      ACCOUNTS_PLUS_V3_25K_MONTHLY: "price_0NXWlf7vaQQgJjsxbBzl67Lm",
      ACCOUNTS_PLUS_V3_50K_MONTHLY: "price_0NXWlf7vaQQgJjsxW3ycFQEp",
      ACCOUNTS_PLUS_V3_75K_MONTHLY: "price_0PgbYj7vaQQgJjsxdHk0FOfl",
      ACCOUNTS_PLUS_V3_100K_MONTHLY: "price_0NXWlf7vaQQgJjsxVCYWSyVC",
      ACCOUNTS_PLUS_V3_150K_MONTHLY: "price_0PgbYm7vaQQgJjsxIDgbIUc7",
      ACCOUNTS_PLUS_V3_200K_MONTHLY: "price_0NXWlf7vaQQgJjsx3eHZSPrD",
      ACCOUNTS_PLUS_V3_300K_MONTHLY: "price_0NXWlf7vaQQgJjsxV1lDjKcc",
      // Plus V3 EV Plan Intital Testing Price IDs
      ACCOUNTS_PLUS_V3_20M_YEARLY: "price_0P9xgS7vaQQgJjsx80LNMVdG",
      ACCOUNTS_PLUS_V3_10M_YEARLY: "price_0OwACY7vaQQgJjsxTtImg8nc",
      ACCOUNTS_PLUS_V3_5M_YEARLY: "price_0OwADH7vaQQgJjsxyW9pXkOR",
      ACCOUNTS_PLUS_V3_20M_MONTHLY: "price_0P9xgh7vaQQgJjsx4bCA8YIu",
      ACCOUNTS_PLUS_V3_10M_MONTHLY: "price_0OwAC67vaQQgJjsxD3rzVoZx",
      ACCOUNTS_PLUS_V3_5M_MONTHLY: "price_0Oz7oA7vaQQgJjsxiBG03iaO"
    }
  };
  switch (e) {
    case r:
    case _:
      return n;
    case "staging":
    case "prod-sandbox":
    case "development":
    default:
      return c;
  }
}, ie = (e) => e === r || e === _ ? "pk_live_EF4qk7RfFBjZnnbweBoJPBtf" : "pk_test_rzpxG79p6THbLKHS4KoqFLTe", se = (e, t) => {
  if (t === "test")
    return "";
  if (t === "development" || t === "perf")
    return "e5d324086cddadbb2d14da9dd483bfd9";
  switch (e) {
    case r:
      return "844501a921b53fe9edfb105600bd14f8";
    case "staging":
    case "prod-sandbox":
      return "3c3ebc5b0250a69e599349b9cf7f0992";
    case "development":
      return "";
    case _:
      return "7209749aaf591e3e8a74aa40f0388485";
    default:
      return "";
  }
}, ne = (e, t) => {
  if (t === "test")
    return "";
  switch (e) {
    case "production":
      return "https://e3993fc28c3b42e18f51d2cdb24e04f6@o13027.ingest.sentry.io/5669140";
    case "staging":
    case "prod-sandbox":
    case "development":
    default:
      return "https://e3993fc28c3b42e18f51d2cdb24e04f6@o13027.ingest.sentry.io/5669140";
  }
}, pe = (e, t) => {
  if (t === "test")
    return "";
  switch (e) {
    case r:
    case _:
    case d:
      return "https://af219e1dd5d04e6db907344d7dfbaa6a@o13027.ingest.sentry.io/5367982";
    default:
      return "";
  }
}, oe = (e) => e === "test" ? "" : "https://f24a040c352f45af811e277a92372da6@o13027.ingest.sentry.io/5974455", de = (e, t) => {
  if (t === "development")
    return "https://local.amplitude.com:3008";
  switch (e) {
    case r:
      return "https://experiment-overlay.prod.us-west-2.amplitude.com";
    case _:
      return "https://experiment-overlay.prod.eu-central-1.amplitude.com";
    case "staging":
      return "https://experiment-overlay.stag2.amplitude.com";
    default:
      return console.warn("Unknown overlay inject host for environment variable"), "";
  }
}, ue = {
  amplitudeOrgId: C(window.__ENVIRONMENT__),
  baseUrl: "https://app.amplitude.com/analytics",
  keys: {
    AG_GRID_LICENSE_KEY: I(),
    AMPLITUDE_SDK_GAIA_KEY: L(
      window.__ENVIRONMENT__,
      a
    ),
    AMPLITUDE_APP_TEAM_INFRASTRUCTURE_KEY: A(
      window.__ENVIRONMENT__,
      a
    ),
    CEREBRO_SENTRY_DSN: ne(
      window.__ENVIRONMENT__,
      a
    ),
    ONENAV_AMPLITUDE_SDK_KEY: se(
      window.__ENVIRONMENT__,
      a
    ),
    ONENAV_SKYLAB_CLIENT_KEY: f(
      window.__ENVIRONMENT__,
      a
    ),
    ONENAV_DATADOG_APP_ID: "357920cd-e21b-44e2-a9a5-c34edf090cd7",
    ONENAV_DATADOG_CLIENT_TOKEN: "pubb3f5636caaa372205e519d422579cf30",
    ONENAV_SENTRY_DSN: "https://136dc13e72cc4ee18515253b3f8165cf@o13027.ingest.sentry.io/4505280404979712",
    FACEBOOK_APP_ID: T(),
    TIKTOK_APP_ID: E(),
    GOOGLE_ADS_CLIENT_ID: "94349717549-nqgopuknlcdrfsn9v74m8ve8818j1jrf.apps.googleusercontent.com",
    SENTRY_DSN: g(a),
    SKYLAB_SENTRY_DSN: pe(
      window.__ENVIRONMENT__,
      a
    ),
    SKYLAB_CLIENT_KEY: m(window.__ENVIRONMENT__, a),
    GROWTH_TEAM_SKYLAB_CLIENT_KEY: M(
      window.__ENVIRONMENT__,
      a
    ),
    STARGATE_SENTRY_DSN: oe(a),
    SLACK_CLIENT_ID: U(
      window.__DEPLOYMENT__,
      window.__ENVIRONMENT__,
      a
    ),
    AMPLI_ENV: u(window.__ENVIRONMENT__, a),
    SSO_CAPTCHA_SITE_KEY: "6LcbtOAlAAAAABqrWUqkkWNX1NiDhyN0sLYwAh7m",
    RECAPTCHA_V3_SITE_KEY: "6Ld6sOAlAAAAAJSDELnDje0yFHpRGVglkL2OWeoq",
    INTERCOM_CLIENT_ID: h(window.__ENVIRONMENT__, a),
    HUBSPOT_CLIENT_ID: V(window.__ENVIRONMENT__, a),
    HUBSPOT_REDIRECT_URI: w(
      window.__ENVIRONMENT__,
      a
    ),
    HUBSPOT_SCOPE: "oauth crm.lists.read crm.lists.write crm.objects.contacts.read crm.import content",
    DATADOG_APP_ID: "fb8a9eb4-42ae-4f15-8773-2bbffdab6e6d",
    DATADOG_CLIENT_TOKEN: "pub0b062d82219f14caa0bdbbd249ae08b5",
    MAILCHIMP_CONFIG: b(window.__ENVIRONMENT__, a),
    QUALTRICS_CONFIG: x(window.__ENVIRONMENT__, a),
    USERFLOW_CLIENT_TOKEN: F(
      window.__ENVIRONMENT__,
      a
    ),
    SALESFORCE_V2_CONFIG: J(
      window.__ENVIRONMENT__,
      a
    ),
    TIKTOKAD_CONFIG: j(window.__ENVIRONMENT__, a),
    SNAPCHATAD_CONFIG: K(window.__ENVIRONMENT__, a)
  },
  ADAPTER_V2_JSONATA_TEMPLATE_CONFIG: X(
    window.__ENVIRONMENT__,
    a
  ),
  ADAPTER_V2_CUSTOMER_TEMPLATE_CONFIGS: G(
    window.__ENVIRONMENT__,
    a
  ),
  MAILCHIMP_WEBHOOK_URL: B(
    window.__ENVIRONMENT__,
    a
  ),
  AMPLITUDE_SDK_ENV_CONFIG: l(
    window.__ENVIRONMENT__,
    a
  ),
  ALGOLIA_INDICES: Y(window.__ENVIRONMENT__),
  ALGOLIA_APP_ID: v(window.__ENVIRONMENT__),
  safeRedirectProtocol: window.__DEPLOYMENT__ === "local" ? "http:" : "https:",
  NAT_GATEWAYS: S(window.__ENVIRONMENT__),
  PRINCIPAL_AWS: Q(window.__ENVIRONMENT__),
  DEFAULT_AWS_REGION: P(window.__ENVIRONMENT__),
  VPCE: O(window.__ENVIRONMENT__),
  USER_AVATAR_ORIGIN: R(window.__ENVIRONMENT__),
  EVENT_SERVER_URL: D(window.__ENVIRONMENT__),
  HTTP_API_URL: y(window.__ENVIRONMENT__, a),
  HTTP_API_V2_URL: k(window.__ENVIRONMENT__, a),
  ENV: window.__ENVIRONMENT__ ?? process.env.NODE_ENV,
  VERSION: process.env.REACT_APP_VERSION,
  HERMES_HOST: H(window.__ENVIRONMENT__, a),
  STARGATE_HOST_URL: W(window.__ENVIRONMENT__, a),
  ORBIT_API_BASE_URL: ee(window.__ENVIRONMENT__, a),
  LIGHTNING_HOST_URL: z(window.__ENVIRONMENT__, a),
  ADMIN_HOST_URL: $(window.__ENVIRONMENT__, a),
  THUNDER_API_BASE_URL: te(a),
  DASH_API_BASE_URL: _e(a),
  ONENAV_HOST_URL: ae(window.__ENVIRONMENT__, a),
  CEREBRO_HOST_URL: re(window.__ENVIRONMENT__, a),
  STRIPE_PRICE_ID_MAP: ce(window.__ENVIRONMENT__, a),
  STRIPE_PUBLISHABLE_KEY: ie(window.__ENVIRONMENT__),
  SLACK_APP_ID: q(window.__ENVIRONMENT__, a),
  DATA_CONNECTIONS_PUBLIC_KEY: Z(
    window.__ENVIRONMENT__,
    a
  ),
  USERFLOW_STREAMING_VERSIONING_FLOW_ID: "0c8689c6-b00e-42b7-9b83-adf6227e226d",
  OVERLAY_INJECT_URL: de(
    window.__ENVIRONMENT__,
    a
  )
};
export {
  N as DefaultAWSRegion,
  ue as default,
  ne as getCerebroClientSentryDsn,
  V as getHubSpotClientId,
  w as getHubSpotRedirectURI,
  h as getIntercomClientId,
  b as getMailchimpConfig,
  se as getOneNavAmplitudeSDKKey,
  ae as getOneNavHost,
  x as getQualtricsConfig,
  J as getSalesforceV2Config,
  pe as getSkylabClientSentryDsn,
  q as getSlackAppId,
  K as getSnapchatAdConfig,
  oe as getStargateClientSentryDsn,
  ie as getStripePublishableKey,
  j as getTiktokAdConfig,
  F as getUserflowClientToken
};
//# sourceMappingURL=_base.js.map
